/*
 * @Author: wangpeng wangpeng@bailongma-inc.com
 * @Date: 2024-05-28 15:35:11
 * @LastEditors: wangpeng wangpeng@bailongma-inc.com
 * @LastEditTime: 2024-10-18 19:36:05
 * @FilePath: /utils/download.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export function downloadFileByUrl(url, fileName, params = {}) {
  const link = document.createElement('a')
  link.style.display = 'none'
  link.href = url
  fileName && link.setAttribute('download', fileName)
  for (const i in params) {
    if (Object.prototype.hasOwnProperty.call(params, i)) {
      link.setAttribute(i, params[i])
    }
  }
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
// 根据URL下载图片
export function downloadImgURL(url, name) {
  const image = new Image()
  image.setAttribute('crossOrigin', 'anonymous')
  image.src = url
  image.onload = () => {
    const canvas = document.createElement('canvas')
    canvas.width = image.width
    canvas.height = image.height
    const ctx = canvas.getContext('2d')
    ctx.drawImage(image, 0, 0, image.width, image.height)
    canvas.toBlob((blob) => {
      const _url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.download = name
      a.href = _url
      a.click()
      a.remove()
      // 用完释放URL对象
      URL.revokeObjectURL(_url)
    })
  }
}
